import React from "react";
import Link from "@components/elements/DocumentLink";
import {twMerge} from "tailwind-merge";


export function Footer(props: { className?: string }) {
    const siteName = process.env.NEXT_PUBLIC_SITE_NAME || process.env.NEXT_PUBLIC_WEBSITE_NAME || "Plugins Database";
    const year = new Date().getFullYear();

    // const [isFeedbackWidgetDisplayed, setIsFeedbackWidgetDisplayed] = React.useState<boolean>(false);
    return (
        <footer className={twMerge("w-full border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900", props.className)}>
            <div className="max-w-6xl mx-auto px-4 py-10 grid gap-10 md:grid-cols-3">
                <div className="flex flex-col gap-3">
                    <div className="text-lg font-semibold">{siteName}</div>
                    <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                        Data-rich search and discovery for every WordPress plugin, tag, language, and author.
                    </p>
                </div>

                <div className="flex flex-col gap-3">
                    <div className="text-xs font-semibold uppercase tracking-wide text-gray-700 dark:text-gray-300">
                        Explore
                    </div>
                    <div className="flex flex-col gap-2 text-sm">
                        <Link href="/plugins">All plugins</Link>
                        <Link href="/tags">Tags</Link>
                        <Link href="/languages">Languages</Link>
                        <Link href="/authors">Authors</Link>
                    </div>
                </div>

                <div className="flex flex-col gap-3">
                    <div className="text-xs font-semibold uppercase tracking-wide text-gray-700 dark:text-gray-300">
                        Company
                    </div>
                    <div className="flex flex-col gap-2 text-sm">
                        <Link href="/about">About</Link>
                    </div>
                </div>
            </div>

            <div className="border-t border-gray-200 dark:border-gray-700">
                <div className="max-w-6xl mx-auto px-4 py-4 text-sm text-gray-600 dark:text-gray-400 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <div>© {year} Plugins Database LTD</div>
                    <div className="flex flex-row flex-wrap gap-4">
                        <Link href="/sitemap.xml">Sitemap</Link>
                    </div>
                </div>
            </div>
            {/* TODO: Add this back when the widget is working and connected to the API */}
            {/*<button*/}
            {/*    className="text-white hover:text-gray-200"*/}
            {/*    onClick={() => setIsFeedbackWidgetDisplayed(true)}>*/}
            {/*    <i className="fas fa-comment-dots"/> Give Feedback*/}
            {/*</button>*/}
            {/*{isFeedbackWidgetDisplayed &&*/}
            {/*    <FeedbackWidget displayButton={false}*/}
            {/*                    startOpen={true}*/}
            {/*                    isWidgetDisplayed={(isDisplayed: boolean) => setIsFeedbackWidgetDisplayed(isDisplayed)}/>*/}
            {/*}*/}
        </footer>
    )
}
